import * as React from 'react';
import {
    AppBar,
    Logout, useTranslate,
    UserMenu,
    useUserMenu,
} from 'react-admin';
import { Link, useNavigate } from 'react-router-dom';
import {
    Box,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Typography,
    useMediaQuery,
    Theme,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import Button from "@mui/material/Button";

const ConfigurationMenu = React.forwardRef((props, ref) => {
    const translate = useTranslate();
    const { onClose } = useUserMenu();
    return (
        <MenuItem
            component={Link}
            // @ts-ignore
            ref={ref}
            {...props}
            to="/configuration"
            onClick={onClose}
        >
            <ListItemIcon>
                <SettingsIcon />
            </ListItemIcon>
            <ListItemText>{translate('pos.configuration')}</ListItemText>
        </MenuItem>
    );
});

const CustomUserMenu = () => (
    <UserMenu>
        <ConfigurationMenu />
        <Logout />
    </UserMenu>
);

const OrganizationName = React.memo(() => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return <div>{user?.first_name} {user?.last_name}</div>;
});

const CustomAppBar = (props: any) => {
    const isLargeEnough = useMediaQuery<Theme>(theme => theme.breakpoints.up('sm'));
    const navigate = useNavigate();
    return (
        <AppBar
            {...props}
            color="secondary"
            elevation={1}
            userMenu={<CustomUserMenu />}
        >
            <Button startIcon={<KeyboardArrowLeft />} onClick={() => navigate(-1)}>
                Back
            </Button>

            <div className="w-4" />
            <Typography
                variant="h6"
                color="inherit"
                sx={{
                    flex: 1,
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                }}
                id="react-admin-title"
            />

            {isLargeEnough && <Box component="span" sx={{ flex: 1 }} />}

            <OrganizationName />
        </AppBar>
    );
};

export default CustomAppBar;
